import type { WordTool } from './builder';
import { readingTools } from './reading';
import { writingTools } from './writing';
import { formattingTools } from './formatting';
import { searchTools } from './search';
import { structureTools } from './structure';
import { commentingTools } from './commenting';

export { buildWordTool, listWordTools } from './builder';
export type {
  WordTool,
  WordToolDefinition,
  ToolValidationError,
  ToolError,
  ToolSuccess,
  ToolResult,
  ToolArgs,
  Prerequisites,
} from './builder';

export const wordTools: WordTool[] = [
  ...readingTools,
  ...writingTools,
  ...formattingTools,
  ...searchTools,
  ...structureTools,
  ...commentingTools,
];
